import React, {useEffect, useRef} from "react";
import SignaturePad from "react-signature-pad-wrapper";
import {Button} from "@material-ui/core";
import UndoIcon from "@material-ui/icons/RotateLeft";
import {styles} from "../theme/theme";

// Same 8:3 shape as the box Core prints.
export const INITIALS_PAD_WIDTH = 320;
export const INITIALS_PAD_HEIGHT = 120;

export default function InitialsPad(props) {
    const {points, onChange, clearLabel} = props;

    const padRef = useRef(null);
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    useEffect(() => {
        const pad = padRef.current;
        if (points && points.length > 0) {
            pad.fromData(points);
        }
        pad.onEnd = () => {
            onChangeRef.current({points: pad.toData(), dataUrl: pad.toDataURL()});
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClear = () => {
        padRef.current.clear();
        onChangeRef.current(null);
    };

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <div style={{
                border: 'dashed 2px ' + styles.colors.fixablyBlack,
                width: INITIALS_PAD_WIDTH,
                height: INITIALS_PAD_HEIGHT,
            }}>
                <SignaturePad
                    ref={padRef}
                    width={INITIALS_PAD_WIDTH}
                    height={INITIALS_PAD_HEIGHT}
                    // Without a CSS size the canvas displays at size x devicePixelRatio.
                    canvasProps={{style: {width: INITIALS_PAD_WIDTH, height: INITIALS_PAD_HEIGHT}}}
                    options={{minWidth: 1.5, maxWidth: 3, penColor: styles.colors.fixablyPrimary}}
                />
            </div>
            <Button
                style={{marginLeft: 12}}
                variant='text'
                color='default'
                onClick={onClear}
                endIcon={<UndoIcon/>}>
                {clearLabel}
            </Button>
        </div>
    );
}
